<script setup lang='ts'>
import type { TableItem } from '@/shared/types'

const props = withDefaults(defineProps<{
  tableData: TableItem[]
  labelWidth?: string
  itemWidth?: string
}>(), {
  tableData: () => [],
  labelWidth: '110px',
  itemWidth: '50%',
})
</script>

<template>
  <table class="table-container w-full " :style="[`--labelWidth:${labelWidth}`, `--itemWidth:${itemWidth}`]">
    <tbody class="flex flex-wrap">
      <template v-for="(v, i) in props.tableData" :key="i">
        <tr v-if="!Object.keys(v).includes('isShow') || v.isShow" class="table-item" :style="v.style">
          <slot name="item" :item="v" :index="i">
            <th class="table-label">
              {{ v.label }}
            </th>
            <td class="table-content flex items-center">
              <template v-if="!v.isComponent">
                <span v-html="v.content" />
              </template>
              <template v-else>
                <component :is="v.content" />
              </template>
              <span
                v-if="v.tips && Object.keys(v.tips).length && v.tips?.content"
                class="table-content__tips"
                :class="[v.tips?.className]"
              >({{ v.tips.content }})</span>
            </td>
          </slot>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<style lang='scss' scoped>
.table {
  &-container {
    --labelWidth: 110px;
    --itemWidth: 50%;
    line-height: 1.5;
    font-size: 14px;
    font-family: Microsoft YaHei;
    --uno: border-1 border-slate-2;
  }
  &-item {
    --uno: flex flex-grow min-w-0 border-b-1 border-slate-2 last:border-b-0 w-[var(--itemWidth)];
  }
  &-label {
    --uno: bg-slate-1 text-right font-normal pr-6 min-h-10 flex flex-col justify-center flex-shrink-0 w-[var(--labelWidth)];
  }
  &-content {
    flex-grow: 1;
    overflow: hidden;
    font-weight: bold;
    min-height: 40px;
    padding: 10px 5px 10px 32px;

    &__tips {
      font-size: 12px;
      font-weight: 400;
    }
  }
}
</style>
